/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  GetV2TeamsPersonasByTeamIdAndPersonaIdParams,
  PutV2TeamsPersonasByTeamIdAndPersonaIdParams,
  DeleteV2TeamsPersonasByTeamIdAndPersonaIdParams,
  GetV2TeamsPersonasByTeamIdParams,
  PostV2TeamsPersonasByTeamIdParams,
  PutV2TeamsPersonasByTeamIdAndPersonaIdBody,
  PostV2TeamsPersonasByTeamIdBody,
  GetV2TeamsPersonasByTeamIdAndPersonaIdResponse,
  PutV2TeamsPersonasByTeamIdAndPersonaIdResponse,
  GetV2TeamsPersonasByTeamIdResponse,
} from '../types';

export class Personas extends Controller {
  async getV2TeamsPersonasByTeamIdAndPersonaId<
    T extends GetV2TeamsPersonasByTeamIdAndPersonaIdResponse,
    D,
    C
  >(
    { teamId, personaId }: GetV2TeamsPersonasByTeamIdAndPersonaIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/personas/${personaId}`,
      axiosConfig
    );
  }

  async putV2TeamsPersonasByTeamIdAndPersonaId<
    T extends PutV2TeamsPersonasByTeamIdAndPersonaIdResponse,
    D,
    C extends PutV2TeamsPersonasByTeamIdAndPersonaIdBody
  >(
    body: C,
    { teamId, personaId }: PutV2TeamsPersonasByTeamIdAndPersonaIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.put<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/personas/${personaId}`,
      body,
      axiosConfig
    );
  }

  async deleteV2TeamsPersonasByTeamIdAndPersonaId<T, D, C extends null>(
    { teamId, personaId }: DeleteV2TeamsPersonasByTeamIdAndPersonaIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined,
    body?: C
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.delete<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/personas/${personaId}`,
      { ...axiosConfig, data: body }
    );
  }

  async getV2TeamsPersonasByTeamId<
    T extends GetV2TeamsPersonasByTeamIdResponse,
    D,
    C
  >(
    { teamId }: GetV2TeamsPersonasByTeamIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/personas`,
      axiosConfig
    );
  }

  async postV2TeamsPersonasByTeamId<
    T,
    D,
    C extends PostV2TeamsPersonasByTeamIdBody
  >(
    body: C,
    { teamId }: PostV2TeamsPersonasByTeamIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/personas`,
      body,
      axiosConfig
    );
  }
}
